module.exports = __webpack_public_path__ + "img/spam.eb31e1f3.svg";